import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageSEO from '../components/PageSEO';

const projects = [
  { title: 'Rénovation complète — Maison bourgeoise', type: 'Rénovation Intérieure', city: 'Châteauroux', surface: '180 m²', image: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=600&q=80', category: 'residential' },
  { title: 'Cuisine contemporaine sur mesure', type: 'Cuisine', city: 'Issoudun', surface: '22 m²', image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=600&q=80', category: 'residential' },
  { title: 'Extension ossature bois', type: 'Extension', city: 'La Châtre', surface: '45 m²', image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&q=80', category: 'residential' },
  { title: 'Rénovation café-restaurant', type: 'Commercial', city: 'Châteauroux', surface: '120 m²', image: 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=600&q=80', category: 'commercial' },
  { title: 'Salle de bain PMR senior', type: 'Salle de Bain', city: 'Déols', surface: '9 m²', image: 'https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=600&q=80', category: 'residential' },
  { title: 'Isolation combles perdus', type: 'Isolation', city: 'Bourges', surface: '95 m²', image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600&q=80', category: 'residential' },
  { title: 'Ravalement façade ancienne bâtisse', type: 'Façade', city: 'Argenton-sur-Creuse', surface: '210 m²', image: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=600&q=80', category: 'residential' },
  { title: 'Aménagement open space bureaux', type: 'Bureau', city: 'Saint-Maur', surface: '80 m²', image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&q=80', category: 'commercial' },
  { title: 'Réfection toiture ardoise', type: 'Toiture', city: 'Vierzon', surface: '130 m²', image: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=600&q=80', category: 'residential' },
];

export default function Realisations() {
  const [filter, setFilter] = useState('all');
  const filtered = filter === 'all' ? projects : projects.filter((p) => p.category === filter);

  return (
    <>
      <PageSEO
        title="Nos Réalisations — Chantiers Rénovation Berry & Indre"
        path="/realisations"
        description="Découvrez nos chantiers réalisés dans le Berry : rénovation complète, cuisine, salle de bain, isolation, locaux commerciaux à Châteauroux, Issoudun, Bourges et alentours."
      />
      <section className="bg-slate-900 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-sm text-slate-400 mb-4 flex items-center gap-2">
            <Link to="/" className="hover:text-orange-400">Accueil</Link><span>/</span>
            <span className="text-white">Réalisations</span>
          </div>
          <h1 className="text-4xl font-extrabold text-white mb-3">Nos Réalisations</h1>
          <p className="text-slate-400 text-lg max-w-2xl">Découvrez nos chantiers réalisés en Indre et alentours. Chaque projet est unique — le vôtre le sera aussi.</p>
        </div>
      </section>
      <section className="py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex gap-3 mb-10 flex-wrap">
            {[['all', 'Tous les projets'], ['residential', 'Résidentiel'], ['commercial', 'Commercial']].map(([val, label]) => (
              <button key={val} onClick={() => setFilter(val)} className={`px-5 py-2.5 rounded-lg text-sm font-semibold transition-colors ${filter === val ? 'bg-orange-600 text-white' : 'bg-white text-slate-700 border border-slate-200 hover:border-orange-300'}`}>{label}</button>
            ))}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((p) => (
              <div key={p.title} className="bg-white rounded-xl overflow-hidden border border-slate-200 hover:shadow-lg transition-shadow group">
                <div className="relative h-56 overflow-hidden">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent"></div>
                  <span className="absolute top-3 left-3 bg-orange-600 text-white text-xs font-semibold px-2.5 py-1 rounded-full">{p.type}</span>
                </div>
                <div className="p-5">
                  <h3 className="font-bold text-slate-900 text-base mb-2">{p.title}</h3>
                  <div className="flex items-center gap-4 text-xs text-slate-500">
                    <span>📍 {p.city}</span>
                    <span>📐 {p.surface}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="py-16 bg-orange-600">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-extrabold text-white mb-4">Votre projet sera notre prochaine réalisation</h2>
          <Link to="/devis" className="bg-white text-orange-600 font-bold px-8 py-4 rounded-lg hover:bg-orange-50 transition-colors inline-block">Demander un devis gratuit</Link>
        </div>
      </section>
    </>
  );
}
